/**
 * The keys a dashboard layout names each shared widget by.
 *
 * Never rename a key. A saved dashboard stores the key it was authored with forever, so a
 * rename points every dashboard already saved with the old key at a widget that no longer
 * exists, and the cell renders empty with no error to explain it. Add a new key instead.
 */

/** A Tableau view. */
export const TABLEAU_WIDGET_KEY = 'tableau';

/** A row of KPI cards. */
export const KPI_WIDGET_KEY = 'kpi';

/** A row of dashboard filter controls. */
export const FILTER_WIDGET_KEY = 'filter';

/** A table of the bound query's rows. */
export const GRID_WIDGET_KEY = 'grid';

/** A block of authored HTML. */
export const HTML_WIDGET_KEY = 'html';

/** One line naming what a query's data covers and when it was last refreshed. */
export const PROVENANCE_WIDGET_KEY = 'provenance';
